export default "__VITE_ASSET__ac0cc73b__";